import type { RouteRecordRaw } from "vue-router";
import { PAGE_TYPE } from "@/meta/common";

const productManagementRouter: RouteRecordRaw[] = [
    {
        path: "/productManagement",
        name: "ProductManagement",
        component: () => import("@/layouts/index.vue"),
        meta: {
            title: "商品管理",
            authOptions: [
                {
                    label: "查看",
                    value: "ROLE_PRODUCT_R"
                },
                {
                    label: "管理",
                    value: "ROLE_PRODUCT_MANAGE"
                },
                {
                    label: "处理",
                    value: "ROLE_PRODUCT_DEAL"
                },
                {
                    label: "关闭",
                    value: "ROLE_PRODUCT_CLOSE"
                }
            ]
        },
        children: [
            {
                path: "consignment",
                name: "Consignment",
                component: () => import("@/views/pages/tradeManage/goodsManagement/consignment/index.vue"),
                meta: {
                    title: "寄售商品管理",
                    activeMenu: "Consignment",
                    pageType: PAGE_TYPE.LIST.code,
                    authOptions: [
                        {
                            label: "查看",
                            value: "ROLE_PRODUCT_R"
                        },
                        {
                            label: "管理",
                            value: "ROLE_PRODUCT_MANAGE"
                        },
                        {
                            label: "处理",
                            value: "ROLE_PRODUCT_DEAL"
                        },
                        {
                            label: "关闭",
                            value: "ROLE_PRODUCT_CLOSE"
                        }
                    ]
                }
            },
            {
                path: "consignment/add",
                name: "ConsignmentAdd",
                component: () => import("@/views/pages/tradeManage/goodsManagement/consignment/form.vue"),
                meta: {
                    title: "新增寄售商品",
                    pageType: PAGE_TYPE.CACHE_FORM.code,
                    isNotShowHeader: true,
                    activeMenu: "Consignment",
                    hidden: true,
                    authOptions: [
                        {
                            label: "处理",
                            value: "ROLE_PRODUCT_DEAL"
                        }
                    ]
                }
            },
            {
                path: "consignment/edit",
                name: "ConsignmentEdit",
                component: () => import("@/views/pages/tradeManage/goodsManagement/consignment/form.vue"),
                meta: {
                    hidden: true,
                    pageType: PAGE_TYPE.CACHE_FORM.code,
                    isNotShowHeader: true,
                    title: "编辑寄售商品",
                    activeMenu: "Consignment",
                    authOptions: [
                        {
                            label: "处理",
                            value: "ROLE_PRODUCT_DEAL"
                        }
                    ]
                }
            },
            {
                path: "consignment/detail",
                name: "ConsignmentDetail",
                component: () => import("@/views/pages/tradeManage/goodsManagement/consignment/detail.vue"),
                meta: {
                    title: "寄售商品详情",
                    hidden: true,
                    isNotShowHeader: true,
                    pageType: PAGE_TYPE.LOG.code,
                    activeMenu: "Consignment",
                    authOptions: [
                        {
                            label: "查看",
                            value: "ROLE_PRODUCT_R"
                        },
                        {
                            label: "管理",
                            value: "ROLE_PRODUCT_MANAGE"
                        },
                        {
                            label: "处理",
                            value: "ROLE_PRODUCT_DEAL"
                        },
                        {
                            label: "关闭",
                            value: "ROLE_PRODUCT_CLOSE"
                        }
                    ]
                }
            },
            {
                path: "consignment/audit",
                name: "ConsignmentAudit",
                component: () => import("@/views/pages/tradeManage/goodsManagement/consignment/detail.vue"),
                meta: {
                    title: "审核寄售商品",
                    hidden: true,
                    isNotShowHeader: true,
                    activeMenu: "Consignment",
                    authOptions: [
                        {
                            label: "管理",
                            value: "ROLE_PRODUCT_MANAGE"
                        }
                    ]
                }
            },
            {
                path: "groupPurchase",
                name: "GroupPurchase",
                component: () => import("@/views/pages/tradeManage/goodsManagement/groupPurchase/index.vue"),
                meta: {
                    title: "团购商品管理",
                    activeMenu: "GroupPurchase",
                    pageType: PAGE_TYPE.LIST.code,
                    authOptions: [
                        {
                            label: "查看",
                            value: "ROLE_PRODUCT_R"
                        },
                        {
                            label: "管理",
                            value: "ROLE_PRODUCT_MANAGE"
                        },
                        {
                            label: "处理",
                            value: "ROLE_PRODUCT_DEAL"
                        },
                        {
                            label: "关闭",
                            value: "ROLE_PRODUCT_CLOSE"
                        }
                    ]
                }
            },
            {
                path: "groupPurchase/detail",
                name: "GroupPurchaseDetail",
                component: () => import("@/views/pages/tradeManage/goodsManagement/groupPurchase/detail.vue"),
                meta: {
                    title: "团购商品详情",
                    hidden: true,
                    isNotShowHeader: true,
                    pageType: PAGE_TYPE.LOG.code,
                    activeMenu: "GroupPurchase",
                    authOptions: [
                        {
                            label: "查看",
                            value: "ROLE_PRODUCT_R"
                        },
                        {
                            label: "管理",
                            value: "ROLE_PRODUCT_MANAGE"
                        },
                        {
                            label: "处理",
                            value: "ROLE_PRODUCT_DEAL"
                        },
                        {
                            label: "关闭",
                            value: "ROLE_PRODUCT_CLOSE"
                        }
                    ]
                }
            },
            {
                path: "groupPurchase/add",
                name: "GroupPurchaseAdd",
                component: () => import("@/views/pages/tradeManage/goodsManagement/groupPurchase/form.vue"),
                meta: {
                    title: "新增团购商品",
                    pageType: PAGE_TYPE.CACHE_FORM.code,
                    isNotShowHeader: true,
                    activeMenu: "GroupPurchase",
                    hidden: true,
                    authOptions: [
                        {
                            label: "处理",
                            value: "ROLE_PRODUCT_DEAL"
                        }
                    ]
                }
            },
            {
                path: "groupPurchase/edit",
                name: "GroupPurchaseEdit",
                component: () => import("@/views/pages/tradeManage/goodsManagement/groupPurchase/form.vue"),
                meta: {
                    hidden: true,
                    pageType: PAGE_TYPE.CACHE_FORM.code,
                    isNotShowHeader: true,
                    title: "编辑团购商品",
                    activeMenu: "GroupPurchase",
                    authOptions: [
                        {
                            label: "处理",
                            value: "ROLE_PRODUCT_DEAL"
                        }
                    ]
                }
            },
            {
                path: "groupPurchase/audit",
                name: "GroupPurchaseAudit",
                component: () => import("@/views/pages/tradeManage/goodsManagement/groupPurchase/detail.vue"),
                meta: {
                    title: "审核团购商品",
                    hidden: true,
                    isNotShowHeader: true,
                    activeMenu: "GroupPurchase",
                    authOptions: [
                        {
                            label: "管理",
                            value: "ROLE_PRODUCT_MANAGE"
                        }
                    ]
                }
            },
            {
                path: "bargain",
                name: "Bargain",
                component: () => import("@/views/pages/tradeManage/goodsManagement/bargain/index.vue"),
                meta: {
                    title: "捡漏商品管理",
                    activeMenu: "Bargain",
                    pageType: PAGE_TYPE.LIST.code,
                    authOptions: [
                        {
                            label: "查看",
                            value: "ROLE_PRODUCT_R"
                        },
                        {
                            label: "管理",
                            value: "ROLE_PRODUCT_MANAGE"
                        },
                        {
                            label: "处理",
                            value: "ROLE_PRODUCT_DEAL"
                        },
                        {
                            label: "关闭",
                            value: "ROLE_PRODUCT_CLOSE"
                        }
                    ]
                }
            },
            {
                path: "bargain/detail",
                name: "BargainDetail",
                component: () => import("@/views/pages/tradeManage/goodsManagement/bargain/detail.vue"),
                meta: {
                    title: "捡漏商品详情",
                    hidden: true,
                    isNotShowHeader: true,
                    pageType: PAGE_TYPE.LOG.code,
                    activeMenu: "Bargain",
                    authOptions: [
                        {
                            label: "查看",
                            value: "ROLE_PRODUCT_R"
                        },
                        {
                            label: "管理",
                            value: "ROLE_PRODUCT_MANAGE"
                        },
                        {
                            label: "处理",
                            value: "ROLE_PRODUCT_DEAL"
                        },
                        {
                            label: "关闭",
                            value: "ROLE_PRODUCT_CLOSE"
                        }
                    ]
                }
            },
            {
                path: "bargain/add",
                name: "BargainAdd",
                component: () => import("@/views/pages/tradeManage/goodsManagement/bargain/form.vue"),
                meta: {
                    title: "新增捡漏商品",
                    pageType: PAGE_TYPE.CACHE_FORM.code,
                    isNotShowHeader: true,
                    activeMenu: "Bargain",
                    hidden: true,
                    authOptions: [
                        {
                            label: "处理",
                            value: "ROLE_PRODUCT_DEAL"
                        }
                    ]
                }
            },
            {
                path: "bargain/edit",
                name: "BargainEdit",
                component: () => import("@/views/pages/tradeManage/goodsManagement/bargain/form.vue"),
                meta: {
                    hidden: true,
                    pageType: PAGE_TYPE.CACHE_FORM.code,
                    isNotShowHeader: true,
                    title: "编辑捡漏商品",
                    activeMenu: "Bargain",
                    authOptions: [
                        {
                            label: "处理",
                            value: "ROLE_PRODUCT_DEAL"
                        }
                    ]
                }
            },
            {
                path: "bargain/audit",
                name: "BargainAudit",
                component: () => import("@/views/pages/tradeManage/goodsManagement/bargain/detail.vue"),
                meta: {
                    title: "审核捡漏商品",
                    hidden: true,
                    isNotShowHeader: true,
                    activeMenu: "Bargain",
                    authOptions: [
                        {
                            label: "管理",
                            value: "ROLE_PRODUCT_MANAGE"
                        }
                    ]
                }
            }
        ]
    }
];

export default productManagementRouter;
